import {
  FETCH_HISTORYS,
  FETCH_HISTORYS_FAILURE,
  FETCH_HISTORYS_SUCCESS,
} from "./constants";

// List
export const fetchHistory = (payload) => ({
  type: FETCH_HISTORYS,
  payload,
});
export const fetchHistorySuccess = (payload) => ({
  type: FETCH_HISTORYS_SUCCESS,
  payload,
});
export const fetchHistoryFailure = (payload) => ({
  type: FETCH_HISTORYS_FAILURE,
  payload,
});
